<template>
    <div class="row">
        <div class="col-lg-12">
            <div class="box">
                <div class="box-offset">
                    <div class="">
                        <h3>{{ timesheetInfo.applicant.name ?? name }}
                            {{ timesheetInfo.applicant.last_name ?? '' }}</h3>
                    </div>
                    <div class="">
                        <h6>{{ dateForTimeSheets(timesheetInfo.period.start_date) }} to
                            {{ dateForTimeSheets(timesheetInfo.period.end_date) }}</h6>
                    </div>
                    <div class="table-holder table-responsive ">
                        <div class="table-like">
                            <div class="top-row">
                                <div class="date-column">Date</div>
                                <div class="location-column">
                                    <nobr>Location/Property Name</nobr>
                                </div>
                                <div class="in-out-column">Time In</div>
                                <div class="in-out-column">Time Out</div>
                                <div class="hours-column">
                                    <nobr>Total Hours</nobr>
                                </div>
                            </div>
                            <div
                                v-for="(day, index) in info.schedule.slice(0, 7)"
                                :key="index"
                            >
                                <DayItem
                                    :day="day"
                                    @data-changed="updateForm"
                                ></DayItem>
                            </div>
                            <div class="total-row">
                                <div class="text-right">
                                    <b>Week 1 Total: Regular Hours {{ formatTime(firstWeekRegular) }} Overtime Hours
                                        {{ formatTime(firstWeekOvertime) }}</b>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="table-holder table-responsive ">
                        <div class="table-like">
                            <div class="top-row">
                                <div class="date-column">Date</div>
                                <div class="location-column">
                                    <nobr>Location/Property Name</nobr>
                                </div>
                                <div class="in-out-column">Time In</div>
                                <div class="in-out-column">Time Out</div>
                                <div class="hours-column">
                                    <nobr>Total Hours</nobr>
                                </div>
                            </div>
                            <div
                                v-for="(day, index) in info.schedule.slice(7, 14)"
                                :key="index"
                            >
                                <DayItem
                                    :day="day"
                                    @data-changed="updateForm"
                                ></DayItem>
                            </div>
                            <div class="total-row">
                                <div class="text-right">
                                    <b>Week 2 Total: Regular Hours {{ formatTime(secondWeekRegular) }} Overtime Hours
                                        {{ formatTime(secondWeekOvertime) }}</b>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="d-flex mb-4">
                        <div class="mr-3">
                            <b>Total hours</b>
                            <span>{{ formatTime(firstWeekTotal + secondWeekTotal) }}</span>
                        </div>
                        <div class="mr-3">
                            Regular worked hours: <span>{{ formatTime(totalRegularHours) }}</span>
                        </div>
                        <div class="mr-3">
                            Overtime:
                            <span>{{ formatTime(totalOvertime) }}</span>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <div class="form-group form-group-1">
                                <textarea
                                    v-model="info.comment"
                                    type="text"
                                    class="form-control height-2"
                                    placeholder="Comments/Reminders/Change of address or phone number:"
                                ></textarea>
                            </div>
                        </div>
                        <div class="col-12 mb-4">
                            <h6 v-show="info.trainings.length > 1">Training</h6>
                            <div v-for="(training, index) in info.trainings"
                                 :key="index">
                                <TrainingItem
                                    :training="training"
                                    @data-changed="updateTrainingForm"
                                >
                                </TrainingItem>
                            </div>
                        </div>
                        <div class="col-12">
                            <div class="text-right mb-4">
                                <button
                                    class="btn btn--outline-primary btn--small"
                                    @click="addTraining"
                                >+Add Training
                                </button>
                            </div>
                        </div>

                        <div class="col-sm-12" v-show="!timesheetInfo.isSubmitted">
                            <div class="form-group form-group-1">
                                <div class="form-check">
                                    <input
                                        class="form-check-input-checkbox"
                                        type="checkbox"
                                        id="home-office"
                                        v-model="info.isAgree">
                                    <label class="form-check-label" for="home-office">
                                        I agree that this is true to the best of your knowledge and you were in fact
                                        working during the time you say you were.
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-12" v-show="!timesheetInfo.isSubmitted">
                            <div class="form-group form-group-1">
                                <div class="form-check">
                                    <input
                                        class="form-check-input-checkbox"
                                        type="checkbox"
                                        id="er"
                                        v-model="info.isAgreeWithPayDate"
                                    >
                                    <label class="form-check-label" for="er">
                                        <b>I acknowledge that the pay day is [{{paymentDate}}]</b>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 text-right ">
                            <div class="btns-wrap">
                                <button
                                    class="btn btn--outline-primary w-100 w-sm-auto"
                                    @click="backToPeriods(timesheetInfo)"
                                >Cancel
                                </button>
                                <button
                                    v-if="!timesheetInfo.isSubmitted"
                                    class="btn btn--outline-primary w-100 w-sm-auto ml-auto"
                                    @click="prepareInfoAndValidate('save')">
                                    Save and Close
                                </button>
                                <button
                                    v-if="showSubmitButton"
                                    class="btn btn--secondary w-100 w-sm-auto"
                                    @click="prepareInfoAndValidate('submit')">
                                    Submit
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
import DateConverter from "../../../../../resources/js/mixins/DateConverter";
import moment from 'moment';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import DayItem from "./DayItem.vue";
import PersonalDetailsForm from "../../../AppUser/resources/js/CommonForms/PersonalDetailsForm.vue";
import TrainingItem from "./TrainingItem.vue";
import TimeSheetService from "./services/TimeSheetService";
import TimesheetCalculation from "../../../../../resources/js/mixins/TimesheetCalculation";


export default {
    name: 'Timesheet',
    mixins: [DateConverter, TimesheetCalculation,],
    components: {TrainingItem, PersonalDetailsForm, DayItem, DatePicker,},
    props: {
        timesheetInfo: {
            type: Object,
            required: true,
        },
        isEmployee: {
            type: Boolean,
            required: false,
        }
    },
    computed: {
        showSubmitButton() {
            if (this.isEmployee) {
                return !this.timesheetInfo.isSubmitted;
            } else {
                return true
            }
        }
    },
    data() {
        return {
            info: {
                trainings: this.timesheetInfo.trainings ?? [],
                schedule: this.timesheetInfo.schedule ?? [],
                comment: this.timesheetInfo.comment ?? null,
                isAgreeWithPayDate: this.timesheetInfo.isAgreeWithPayDate ?? false,
                isAgree: Boolean(this.timesheetInfo.isAgree) ?? false,
                isSubmitted: Boolean(this.timesheetInfo.isSubmitted) ?? false,
                regular: null,
                overtime: null,
            },
            totalRegularHours: null,
            totalOvertime: null,

            firstWeekRegular: null,
            firstWeekTotal: null,
            firstWeekOvertime: null,

            secondWeekRegular: null,
            secondWeekOvertime: null,
            secondWeekTotal: null,

            paymentDate: null,
            arrayOfDays: [],
        }
    },
    methods: {
        addTraining() {
            this.info.trainings.push({
                id: null,
                index: this.info.trainings.length,
                location: null,
                trainer: null,
                training_start_day: null,
                training_end_day: null,
                training_start_time: null,
                training_end_time: null,
            })
        },
        backToPeriods(timesheetInfo) {
            if (this.isEmployee) {
                window.location.href = '/application/profile?tab=Time%20Sheet'
            } else {
                window.location.href = `/master-admin/timesheets/periods/${timesheetInfo.period.id}/timesheets?period=${timesheetInfo.period.id}`
            }
        },
        createWeeks() {
            const endDate = moment(this.timesheetInfo.period.start_date).add(13, 'days');
            for (let start = moment(this.timesheetInfo.period.start_date); start.isSameOrBefore(endDate); start.add(1, 'days')) {
                const formattedDate = start.format('dddd|MMMM D, YYYY');
                this.arrayOfDays.push(formattedDate);
            }
            if (this.isEmployee) {
                this.generateSchedule()
            } else if (!this.timesheetInfo.schedule) {
                this.generateSchedule()
            }
        },
        generateSchedule() {
            this.arrayOfDays.forEach(day => {
                this.info.schedule.push({
                    index: day,
                    date: day,
                    location: null,
                    time_in: null,
                    time_out: null,
                    result: null,
                });
            });
            if (this.isEmployee) {
                this.getPaymentDate()
            }
        },
        async prepareInfoAndValidate(method) {
            this.$showLoadingMessage()
            if (method === 'save') {
                this.info.isSubmitted = false
            } else if (method === 'submit') {
                this.info.isSubmitted = true
            }

            if (this.isEmployee) {
                if (this.info.isAgree === true && this.info.isAgreeWithPayDate === true) {
                    await this.sendTimesheetInfo()
                } else {
                    this.$showValidationErrorMessage('Please read the terms and conditions and check the box');
                }
            } else {
                this.info.isAgree = true
                this.info.isAgreeWithPayDate = true
                await this.sendTimesheetInfo()
            }
        },
        async sendTimesheetInfo() {
            this.info.overtime = this.totalOvertime
            this.info.regular = this.totalRegularHours
            if (this.isEmployee) {
                try {
                    await TimeSheetService.updateTimesheetByEmployee(this.timesheetInfo.period.id, this.timesheetInfo.id, this.info)
                    this.$showSuccessMessage('Your timesheet has been submitted!')
                    setTimeout(() => {
                        window.location.href = '/application/profile?tab=Time Sheet'
                    },1000)
                } catch (e) {
                    console.error(e)
                    this.$showErrorMessage('This timesheet was not saved')
                }
            } else {
                try {
                    await TimeSheetService.updateTimesheetByAdmin(this.timesheetInfo.period.id, this.timesheetInfo.id, this.info)
                    this.$showSuccessMessage('Your timesheet has been submitted!')
                    setTimeout(() => {
                        window.location.href = `/master-admin/timesheets/periods/${this.timesheetInfo.period.id}/timesheets?period=${this.timesheetInfo.period.id}`
                    },1000)
                } catch (e) {
                    console.error(e)
                    this.$showErrorMessage('This timesheet was not saved')
                }
            }
        },
        updateForm(result) {
            const index = this.info.schedule.findIndex(day => day.index === result.index);
            if (index !== -1) {
                this.info.schedule.splice(index, 1, result);
            }
            this.calculateTotal('first')
            this.calculateTotal('second')
            this.formatTime(this.firstWeekTotal)
            this.formatTime(this.secondWeekTotal)
            this.formatTime(this.firstWeekTotal + this.secondWeekTotal)
            this.calculateRegularAndOvertime();
        },
        updateTrainingForm(result) {
            const index = this.info.trainings.findIndex(training => training.index === result.index);
            if (index !== -1) {
                this.info.trainings.splice(index, 1, result);
            }
        }
    },
    mounted() {
        this.createWeeks()
    },

}

</script>

<style scoped>
</style>
